"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSnackbarStyles = exports.snackbarVars = exports.snackbarCommon = void 0;
var _constants = require("../../components/constants");
var _Text = require("../../components/Text/Text.util");
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _getRgbaFromHex = _interopRequireDefault(require("../../utils/getRgbaFromHex"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var snackbarCommon = exports.snackbarCommon = ["background", "zIndex"].concat(_toConsumableArray(_commonProps.defaultCommonProps));
var snackbarVars = exports.snackbarVars = (0, _initVars.default)({
  applied: snackbarCommon,
  variables: [{
    key: "snackbarHorizontal",
    defaultUnit: "px"
  }, {
    key: "snackbarVertical",
    defaultUnit: "px"
  }]
});
var styles = function styles(theme) {
  return {
    variables: snackbarVars.styles,
    root: _objectSpread(_objectSpread({
      display: "flex",
      boxSizing: "border-box",
      padding: [theme.spacing.base * 1.5, theme.spacing.base * 2],
      gap: theme.spacing.base,
      background: theme.colors.baseContrast010,
      zIndex: _constants.Z_INDEX.Snackbar,
      justifyContent: "space-between",
      alignItems: "center",
      minWidth: theme.spacing.base * 36,
      maxWidth: theme.spacing.base * 71,
      minHeight: theme.spacing.base * 7,
      position: "fixed",
      transition: "400ms ease all",
      userSelect: "none",
      cursor: "pointer",
      "& a": {
        textDecoration: "none",
        color: theme.colors.primary
      },
      fontFamily: theme.typography.fontFamily
    }, (0, _Text.setTextCssVars)({
      color: theme.colors.baseContrast090,
      fontWeight: theme.typography.fontWeight,
      fontSize: theme.typography.fontSize,
      lineHeight: 1.4
    })), {}, {
      transform: "translate(".concat(snackbarVars.get("snackbarHorizontal"), ", ").concat(snackbarVars.get("snackbarVertical"), ")")
    }),
    center: {
      insetInlineStart: "50%"
    },
    left: {
      insetInlineStart: 0
    },
    right: {
      insetInlineEnd: 0
    },
    top: {
      top: 0
    },
    bottom: {
      bottom: 0
    },
    rootOpen: {
      boxShadow: "0px 3px 5px -1px ".concat((0, _getRgbaFromHex.default)(theme.colors.baseShadow, 0.2), ", 0px 6px 10px 0px ").concat((0, _getRgbaFromHex.default)(theme.colors.baseShadow, 0.14), ", 0px 1px 18px 0px ").concat((0, _getRgbaFromHex.default)(theme.colors.baseShadow, 0.12))
    },
    rootClosed: {
      marginTop: "0 !important",
      marginBottom: "0 !important"
    },
    message: {
      "p&": {
        padding: [theme.spacing.base, 0],
        margin: 0
      }
    },
    button: {
      flexShrink: 0
    },
    children: {
      padding: [theme.spacing.base, 0],
      margin: 0,
      width: "100%"
    }
  };
};
var useSnackbarStyles = exports.useSnackbarStyles = (0, _createUseStyles.default)(styles, {
  name: "Snackbar"
});